// this file is @generated

export interface EventTypeIn {
  archived?: boolean;
  deprecated?: boolean;
  description: string;
  /**
   * Deprecated, use `featureFlags` instead.
   *
   * @deprecated
   */
  featureFlag?: string | null;
  featureFlags?: string[] | null;
  /** The event type group's name */
  groupName?: string | null;
  /** The event type's name */
  name: string;
  /** The schema for the event type for a specific version as a JSON schema. */
  schemas?: any | null;
}

export const EventTypeInSerializer = {
  _fromJsonObject(object: any): EventTypeIn {
    return {
      archived: object["archived"],
      deprecated: object["deprecated"],
      description: object["description"],
      featureFlag: object["featureFlag"],
      featureFlags: object["featureFlags"],
      groupName: object["groupName"],
      name: object["name"],
      schemas: object["schemas"],
    };
  },

  _toJsonObject(self: EventTypeIn): any {
    return {
      archived: self.archived,
      deprecated: self.deprecated,
      description: self.description,
      featureFlag: self.featureFlag,
      featureFlags: self.featureFlags,
      groupName: self.groupName,
      name: self.name,
      schemas: self.schemas,
    };
  },
};
